import { z } from 'zod';
import { UseSchema } from '../../common';
import { savedViewStateSchema } from './saved-view-create.input';

export const savedViewUpdateDtoSchema = z.object({
  name: z.string().min(1).max(255).optional(),
  thumbnail: z.string().nullable().optional(),
  state: savedViewStateSchema.optional(),
  bcfFileId: z.string().uuid().nullable().optional(),
  isPublic: z.boolean().optional(),
});

@UseSchema(savedViewUpdateDtoSchema)
export class SavedViewUpdateDto {}
export interface SavedViewUpdateDto extends z.input<typeof savedViewUpdateDtoSchema> {}
